@if (appFacadeService.isInvoiceSelectableAndAvailable(invoice.Id) | async) {
<div class="checkbox">
    <por-base-checkbox
        #check
        [isChecked]="(appFacadeService.isInvoiceAvailableInState(invoice.Id) | async) || params.value"
        (checkboxChange)="onCheckboxChange($event)"
        [showLabel]="false"></por-base-checkbox>
</div>
}
